import React from 'react';
import {Table , DatePicker, Modal, Form, Icon, Input, Button, message, Radio, Row, Select,Switch,InputNumber } from 'antd';
import {connect} from "react-redux";
import {updateTicketCheckinpoints,findTicketCheckinpoint} from "../../services/checkinpoint";
import {findSubAccounts} from "../../services/subAccounts";
import lodash from "lodash"
import moment from 'moment';
import {isValidity} from "../../services/global";
import PurchaseServiceTips from "../PurchaseServiceTips";



class EvtViewCheckinpointTickets extends React.Component {


 

    constructor(props) {
        super(props);
        this.pstView =null;
        this.state = {
            isMember:'SENIORMEMBER',
            permissionPass: false,
            beginTime:null,
            formLoading: false,
            checkinpointTickets:[],
            checkedTicketIds:[],


        }
    }

    componentDidMount() {
        this.fetchData();
        // isValidity('CHECKINTIMING', (vaild) => this.setState({ permissionPass: vaild}));
    }

    componentWillReceiveProps(nextProps) {

    }

    fetchData = () => {
        findTicketCheckinpoint({checkinpointId: this.props.data.id}).then(res => {
            if (res.code === 200) {
                this.setState({checkinpointTickets: res.data});
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        });
    }
    

    changeFormLoading = (loading) => {
        this.setState({
            formLoading: loading
        })
    }

    onSubmit = () => {
        let arrTicket= this.state.checkedTicketIds.map(o=>({ticketingId:o}))
        updateTicketCheckinpoints(Object.assign({checkinpointId:this.props.data.id},{__self__:arrTicket})).then(res => {
            if (res.code == 200) {
                message.info("保存成功!");
                this.fetchData();
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        }).finally(() => {
            this.changeFormLoading(false)
        })
    }




    render() {
        const {getFieldDecorator, getFieldValue} = this.props.form;
        const {data,evt} = this.props;
        console.log(evt)

        return (
            <div>
                <Modal
                    width={550}
                    title={`签到点-${data.name}(票种分配管理)`}
                    visible={this.props.visible}
                    onCancel={() => this.props.hide()}
                    footer={null}
                >
                    <div>
                        <Form.Item
                            label="选择可允许签到的票种（空是不限制）"
                        >
                            <Select style={{ width: 450 ,}}
                                    mode="multiple"
                                    placeholder="请选择"
                                    onChange={e=>{this.setState({checkedTicketIds:e})}}
                            >
                                {evt.ticketings.map((obj,index)=>{
                                    return <Select.Option key={index} value={obj.id}>{obj.name}</Select.Option>
                                })}
                            </Select>
                            <a href="#" style={{marginLeft:20}} onClick={this.onSubmit}>保存</a>
                        </Form.Item>
                        <Form.Item
                            label="已绑定的票种"
                        >
                            <Table
                                size="small"
                                pagination={false}
                                columns={
                                    [{
                                        title: '票种名',
                                        dataIndex: 'ticketing.name',
                                        // width:120,

                                    }, ]
                                }
                                dataSource={this.state.checkinpointTickets} />

                        </Form.Item>

                    </div>

                </Modal>
                <PurchaseServiceTips
                    ref={(pst) => {
                        this.pstView = pst
                    }}
                    member={this.state.isMember}
                />
            </div>
        );
    }
}


EvtViewCheckinpointTickets.contextTypes = {};

EvtViewCheckinpointTickets.defaultProps = {};

EvtViewCheckinpointTickets.propTypes = {}


const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return {cmEnums};
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewCheckinpointTickets));




// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewCheckinpointTickets.jsx